var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7106 12.4043C10.5684 13.2457 9.15043 13.6244 7.74081 13.4647C6.33118 13.3049 5.03398 12.6184 4.10908 11.5427C3.18418 10.467 2.6999 9.08156 2.75325 7.66392C2.80661 6.24627 3.39366 4.90113 4.3968 3.89799C5.39993 2.89485 6.74507 2.3078 8.16272 2.25445C9.58036 2.20109 10.9658 2.68538 12.0415 3.61027C13.1172 4.53517 13.8037 5.83238 13.9635 7.242C14.1233 8.65163 13.7445 10.0696 12.9031 11.2117L16.0024 14.31C16.0853 14.3872 16.1518 14.4804 16.1979 14.5839C16.244 14.6874 16.2688 14.7991 16.2708 14.9124C16.2728 15.0257 16.252 15.1382 16.2096 15.2433C16.1671 15.3484 16.104 15.4438 16.0238 15.5239C15.9437 15.604 15.8483 15.6672 15.7432 15.7096C15.6382 15.7521 15.5256 15.7729 15.4123 15.7709C15.299 15.7689 15.1873 15.7441 15.0838 15.698C14.9803 15.6519 14.8872 15.5854 14.8099 15.5025L11.7106 12.4043ZM12.3124 7.875C12.3124 8.91929 11.8976 9.92081 11.1592 10.6592C10.4207 11.3977 9.41922 11.8125 8.37493 11.8125C7.33064 11.8125 6.32912 11.3977 5.59069 10.6592C4.85227 9.92081 4.43743 8.91929 4.43743 7.875C4.43743 6.83071 4.85227 5.82919 5.59069 5.09077C6.32912 4.35234 7.33064 3.9375 8.37493 3.9375C9.41922 3.9375 10.4207 4.35234 11.1592 5.09077C11.8976 5.82919 12.3124 6.83071 12.3124 7.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ac033a193801f01bb9875a30f8313c55.svg";
export { ForwardRef as ReactComponent };